let state = {
    blockUI: false,
	applicationName: "",
	authenticated: false,
	apikey: "",
    print: false
}

export default state;



// WEBPACK FOOTER //
// ./src/redux/util/initialState.js